import { logout } from '../services/auth';
import React from 'react';

const Logout = () => {
  logout();
  return <></>;
};

export default Logout;
